//* Importing hooks from react-router-dom
import { useNavigate } from "react-router-dom";

//* Importing icons
import { MdKeyboardDoubleArrowLeft } from "react-icons/md";

//* Importing constants
import { STORAGE_URL } from "../../../constants/consts";

//* Importing styles
import styles from './style.module.scss';

//* Importing images
import user4 from "../../../assets/images/default.png";

//* Importing hooks from react-redux
import { useSelector } from "react-redux";

export default function SidebarHeader({ shrunk, handleShrunk, isMobile }) {
  const { me } = useSelector((store) => store.auth);
  const navigate = useNavigate();

  return (
    <div className={styles.sidebarHeader}>
      <div
        className={styles.profileSection}
        onClick={() => navigate("/edit-profile")}
      >
        <img
          src={me?.image && me?.image !== "" ? STORAGE_URL + me?.image : user4}
          alt="Usuário"
          className={`${styles.profileImage} ${shrunk ? styles.shrunk : ''}`}
        />
        <div className={styles.profileInfo}>
          <span
            className={`${styles.profileTitle} ${shrunk ? styles.shrunk : ''}`}
          >
            Meu perfil
          </span>
          <span
            className={`${styles.profileName} ${shrunk ? styles.shrunk : ''}`}
          >
            {me?.name}
          </span>
        </div>
      </div>

      {!isMobile && (
        <MdKeyboardDoubleArrowLeft
          className={`${styles.toggleButton} ${shrunk ? styles.shrunk : ''}`}
          onClick={handleShrunk}
        />
      )}
    </div>
  );
}
